import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = loading | false = not logged in | object = logged
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await adminApi.me();
      setAdmin(me);
    } catch {
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { token, admin: a } = await adminApi.login(email, password);
    if (token) localStorage.setItem("admin_token", token);
    setAdmin(a);
    return a;
  }, []);

  const logout = useCallback(async () => {
    try { await adminApi.logout(); } catch { /* ignore */ }
    localStorage.removeItem("admin_token");
    setAdmin(false);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return ctx;
}
